<template>
    <div class="py-4 container-fluid">
        <transition name="banner-slide">
            <div v-if="isSyncing || progress === 100">
                <RvoSyncBanner />
            </div>
        </transition>
        <div class="row">
            <div class="col-lg-12">
                <div class="row mt-4">
                    <div class="multisteps-form mb-9">
                        <div class="col-12 col-lg-10 m-auto">
                            <div class="card">
                                <div class="card-header p-0 position-relative mt-n4 mx-3 z-index-2">
                                    <div class="bg-gradient-success shadow-success border-radius-lg pt-4 pb-3">
                                        <div class="multisteps-form__progress">
                                            <button class="multisteps-form__progress-btn" type="button"
                                                :title="$t('death.Death_from_UBN')" :class="activeStep >= 0 ? activeClass : ''"
                                                @click="activeStep = 0">
                                                <span>{{ $t('death.Death_from_UBN') }}</span>
                                            </button> 
                                            <button class="multisteps-form__progress-btn" type="button"
                                                :title="$t('death.Animal')" :class="activeStep >= 1 ? activeClass : ''"
                                                @click="activeStep = 1">
                                                <span>{{ $t('death.Animal') }}</span>
                                            </button>
                                            <button class="multisteps-form__progress-btn" type="button" :title="$t('death.Date_of_death')"
                                                :class="activeStep >= 2 ? activeClass : ''" @click="activeStep = 2">
                                                {{ $t('death.Date_of_death') }}
                                            </button>
                                            <button class="multisteps-form__progress-btn" type="button" :title="$t('death.Destructor')"
                                                :class="activeStep >= 3 ? activeClass : ''" @click="activeStep = 3">
                                                {{ $t('death.Destructor') }}
                                            </button>
                                            
                                        </div>
                                    </div>
                                </div>
                                <div class="card-body">
                                    <form class="multisteps-form__form" @submit.prevent="submitForm">
                                        <ubn-info 
                                            v-if="activeStep === 0" 
                                            :class="activeStep === 0 ? activeClass : ''"
                                            :formData="formData" 
                                            :nextStep="nextStep"                                            
                                            :ubns="formData.ubns"                                            
                                            @request-animals="handleAnimalRequest"
                                            @update:formData="updateFormData"
                                        />
                                        <animal-info 
                                            v-if="activeStep === 1" 
                                            :class="activeStep === 1 ? activeClass : ''"
                                            :formData="formData" 
                                            :prevStep="prevStep"
                                            :nextStep="nextStep"
                                            :animals="formData.animals"
                                            @update:formData="updateFormData"
                                        />
                                        <date-info 
                                            v-if="activeStep === 2" 
                                            :class="activeStep === 2 ? activeClass : ''"                                            
                                            :formData="formData"
                                            :prevStep="prevStep"
                                            :nextStep="nextStep"                                            
                                            @update:formData="updateFormData"
                                        />
                                        <destructor-info
                                            v-if="activeStep === 3" 
                                            :class="activeStep === 3 ? activeClass : ''"
                                            :formData="formData" 
                                            :departureubns="formData.departureubns" 
                                            ref="destructorInfoRef"                                       
                                            :prevStep="prevStep"
                                            :emitter="emitter"
                                        />
                                        
                                        <div class="button-row d-flex">
                                            <button
                                                v-if="activeStep === 3"
                                                @click="saveForm"
                                                :disabled="isSaving"
                                                :class="[
                                                    'btn mb-0 btn-sm bg-gradient-success ms-auto',
                                                    { 'disabled opacity-75': isSaving }
                                                ]"
                                                type="button"
                                            >
                                                <span v-if="isSaving" class="spinner-border spinner-border-sm me-2"></span>
                                                {{ isSaving ? $t('common.Saving') : $t('common.Save') }}
                                            </button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row"></div>
    </div>
</template>

<script>
import RvoSyncBanner from "@/components/RvoSyncBanner.vue";
import UbnInfo from "./components/UBN.vue";
import AnimalInfo from "./components/Animal.vue";
import DestructorInfo from "./components/Destructor";
import DateInfo from "./components/Date.vue";
import * as Choices from "choices.js";
import { nextTick } from 'vue'
import axios from 'axios'
import mitt from 'mitt';
import { mapState, mapGetters } from 'vuex'

export default {
    name: 'Death_page',
    data() {
        return {
            emitter: mitt(),
            activeStep: 0,
            activeClass: "js-active position-relative",
            formSteps: 4,
            formData: {
                associationId: '',
                ubnId: '',
                animalIds: '',
                departureUbnId: '',
                departureUbn: '',
                exportCountryId: '',
                departureDate: null,

                // RVO/I&R notification
                sendToRvo: true,

                ubns:[],
                departureubns:[],
                animals:[]
            },
            // Store Choices instance            
            choicesInstanceUBN: null,
            choicesInstanceDepartureUBN: null,
            choicesInstanceAnimal: null,
            choicesExportCountry: null,
            isSaving: false
        };
    },
    components: {
        UbnInfo,
        AnimalInfo,        
        DestructorInfo,
        DateInfo,
        RvoSyncBanner
    },
    async mounted() 
    {
        // Clear any previous RVO synchronization state
        this.$store.commit('rvoSync/CLEAR_SYNC');

        try {  
            this.associationId = this.$route.params.id;
            await this.fetchAllUBN();

        } catch (e) {
            const errorMessage = e.response?.data?.message || e.message || this.$t('errors.Something_went_wrong');
            this.$showError(`${this.$t('errors.Contact_system_admin')}: ${errorMessage}`);
        }
    },    
    computed: {
        userRoleName() {
            return this.$store.state.user?.roleName;
        },
        ...mapState('rvoSync', ['isSyncing', 'progress', 'cancelSource']),
        ...mapGetters('rvoSync', ['elapsedSeconds'])
    },
    methods: {
        async nextStep() {
            if (this.activeStep < this.formSteps -1) {
                this.activeStep += 1;
                //console.log(this.activeStep);
            } else {
                this.activeStep -= 1;
                //console.log(this.activeStep);
            }   

            if(this.activeStep == 3) {
                await this.fetchAllUBN();
                await this.fetchAllDestructorUBN();
            }
        },
        async prevStep() {
            if (this.activeStep > 0) {
                this.activeStep -= 1;
                //console.log(this.activeStep);

                if(this.activeStep == 0) {
                    //await this.fetchAllUBNData();
                    await this.fetchAllUBN();
                }
                
                if(this.activeStep == 1) {
                    //await this.fetchAllAnimals();
                }

                if(this.activeStep == 3) {
                    await this.fetchAllUBN();
                    await this.fetchAllDestructorUBN();
                }
            }
        },        
        async fetchAllUBN() 
        {
            try { 
                this.$store.commit('setShowLoading', true);

                const role = this.$store.state.roleName;
                const ubnId = this.$store.state.keeperLocationId;

                const response = await axios.get("Location/getallbyassociationdeath", {
                    params: {
                        associationId: this.associationId
                    }
                });                
                const result = response.data;

                if (result.success && Array.isArray(result.data)) {
                    let avl_ubns = result.data;

                    if (role === 'Keeper' && ubnId) {                        
                        avl_ubns = avl_ubns.filter(l => l.id === ubnId);

                        if (avl_ubns.length) {
                            this.formData.ubnId = avl_ubns[0].id;
                            this.formData.ubn = `${avl_ubns[0].ubn} - ${avl_ubns[0].locationFullAddressDropDown}`;
                        }
                    }

                    this.formData.ubns = avl_ubns;
                    await nextTick();

                    this.initializeChoicesDropdown({
                        id: "ubnId",
                        dataList: this.formData.ubns,
                        selectedValue: this.formData.ubnId,
                        instanceKey: "choicesInstanceUBN"
                    });
                } else {    
                    this.$showSuccess('errors.Error_fetching_ubns');
                }                
            } catch (e) {
                const errorMessage = e.response?.data?.message || e.message || this.$t('errors.Something_went_wrong');
                this.$showError(`${this.$t('errors.Contact_system_admin')}: ${errorMessage}`);
            } finally {
                this.$store.commit('setShowLoading', false);
            }
        },        
        async fetchAllDestructorUBN()
        {
            this.$store.commit('setShowLoading', true);
            try { 
                const response = await axios.get("Location/getalldestructor");
                const result = response.data;

                if (result.success && Array.isArray(result.data.locationList)) {

                    this.formData.departureubns = result.data.locationList;
                    await nextTick();

                    this.initializeChoicesDropdown({
                        id: "departureUbnId",
                        dataList: this.formData.departureubns,
                        selectedValue: this.formData.departureUbnId,
                        instanceKey: "choicesInstanceDepartureUBN"
                    });
                } else {    
                    this.$showSuccess('errors.Error_fetching_ubns');
                }   
            } catch (e) {
                const errorMessage = e.response?.data?.message || e.message || this.$t('errors.Something_went_wrong');
                this.$showError(`${this.$t('errors.Contact_system_admin')}: ${errorMessage}`);
            } finally {
                this.$store.commit('setShowLoading', false);
            }
        },        
        async handleAnimalRequest({ ubnId }) {
            this.formData.associationId = this.$route.params.id;
            this.formData.ubnId = ubnId;

            this.$store.commit('setShowLoading', true);
            try {
                const response = await axios.get("Animal/getalldeparture", {
                    params: {
                        associationId: this.$route.params.id,
                        animalTypeId: '1469f04a-a84e-48a5-b79b-bd69f3a5bd51',
                        ubnId
                    }
                });
                if (response.data.success) {
                    if(response.data.count > 0 && Array.isArray(response.data.data)) {
                        this.formData.animals = response.data.data.sort((a, b) => (b.animalNumber ?? '').localeCompare(a.animalNumber ?? ''));
                        this.nextStep();
                    } else {
                        this.$showSuccess('errors.Success_no_animal_found');
                    }
                } else {
                    this.$showError(this.$t('errors.Error_fetching_animals'));
                }
            } catch (e) {
                const errorMessage = e.response?.data?.message || e.message || this.$t('errors.Something_went_wrong');
                this.$showError(`${this.$t('errors.Contact_system_admin')}: ${errorMessage}`);
            } finally {
                this.$store.commit('setShowLoading', false);
            }
        },              
        initializeChoicesDropdown({ id, dataList, selectedValue, instanceKey }) {
            const element = document.getElementById(id);
            if (!element || element.tagName !== "SELECT") {
                console.error(`Choices: Invalid or missing select element with ID "${id}".`);
                return;
            }

            // Destroy previous instance if it exists
            if (this[instanceKey]) {
                this[instanceKey].destroy();
            }

            // Initialize new Choices instance
            this[instanceKey] = new Choices(element, {
                searchEnabled: true,
                itemSelectText: '',
                shouldSort: false,
                placeholder: true,
            });

            // Set selected value if it exists in list
            if (selectedValue) {
                const optionExists = dataList.some(item => item.id === selectedValue);
                this[instanceKey].setChoiceByValue(optionExists ? [selectedValue] : '');
            }
        },
        updateFormData(updatedData) {
            //this.formData = { ...this.formData, ...updatedData };
            Object.assign(this.formData, updatedData);
        },        
        async saveForm() {

            if (this.isSaving) return; // prevent double click
            this.isSaving = true;

            try {
                const isValid = await this.$refs.destructorInfoRef?.validateAndSubmit();
                if (!isValid) {
                    this.isSaving = false;
                    return;
                }

                await this.submitForm();

            } catch (e) {
                console.error(e);
            } finally {
                this.isSaving = false;
            }
        },
        async submitForm() {

            this.$store.commit("setShowLoading", true);

            try {

                const formData = new FormData();
                const ignoredKeys = ["ubns", "departureubns", "animals"];

                for (const key of Object.keys(this.formData)) {

                    if (ignoredKeys.includes(key))
                        continue;

                    const value = this.formData[key];

                    if (key === "departureDate" && value instanceof Date) {
                        formData.append(key, value.toISOString().split("T")[0]);
                    }
                    else if (value !== null && value !== undefined) {
                        formData.append(key, value);
                    }
                }

                const selectedAnimals = this.formData.animals.filter(a =>
                    this.formData.animalIds.includes(a.id)
                );

                let rvoResult = null;

                /*
                * Send death to RVO only when:
                *
                * 1. "Melden aan RVO" is enabled
                * 2. No destructor UBN is supplied
                *
                * If sendToRvo is false, the death is registered
                * only in VeeBoek.
                */
                const shouldSendToRvo = this.formData.sendToRvo === true && !this.formData.departureUbn?.trim();

                if (shouldSendToRvo) {

                    // Hide normal loader so the RVO sync banner can be displayed
                    this.$store.commit("setShowLoading", false);

                    const cancelSource = axios.CancelToken.source();
                    this.$store.commit("rvoSync/START_SYNC", cancelSource);

                    await this.$nextTick();

                    /*
                    * RVO result:
                    *
                    * C + J
                    *     -> success
                    *
                    * C + W + N -> V + W + J
                    *     -> success + warning
                    *
                    * C + F + N
                    *     -> throws error
                    *     -> createDeath() is NOT executed
                    */
                    rvoResult = await this.syncRvo(selectedAnimals, cancelSource);
                }

                /*
                * RVO was either:
                * - successfully synchronized, or
                * - intentionally skipped.
                *
                * Now create the death record in VeeBoek.
                */
                await this.createDeath(formData);

                /*
                * RVO accepted the request but returned a warning.
                * The warning does NOT prevent the death registration.
                */
                const warningMessage = rvoResult?.warningMessage?.trim();

                if (warningMessage) {
                    this.$showWarning(warningMessage);
                }

                // Local death successfully created
                this.$showSuccess(this.$t("errors.Success_departure_created_successfully"));

                this.$router.push("/death");

            }
            catch (e) {

                if (!axios.isCancel(e)) {
                    const message = e.response?.data?.message || e.message || this.$t("errors.Something_went_wrong");
                    this.$showError(message);
                }
            }
            finally {
                this.$store.commit("rvoSync/STOP_SYNC");
                this.$store.commit("setShowLoading", false);
            }
        },
        async submitForm1() {

            this.$store.commit("setShowLoading", true);

            try {

                const formData = new FormData();
                const ignoredKeys = ["ubns", "departureubns", "animals"];

                for (const key of Object.keys(this.formData)) {

                    if (ignoredKeys.includes(key))
                        continue;

                    const value = this.formData[key];

                    if (key === "departureDate" && value instanceof Date) {
                        formData.append(key, value.toISOString().split("T")[0]);
                    }
                    else if (value !== null && value !== undefined) {
                        formData.append(key, value);
                    }
                }

                const selectedAnimals = this.formData.animals.filter(a =>
                    this.formData.animalIds.includes(a.id)
                );

                let rvoResult = null;

                // Synchronize with RVO only when: - "Melden aan RVO" is enabled - No destructor UBN is supplied
                if (this.formData.sendToRvo && !this.formData.departureUbn?.trim()) {

                    this.$store.commit("setShowLoading", false);

                    const cancelSource = axios.CancelToken.source();

                    this.$store.commit("rvoSync/START_SYNC", cancelSource);

                    await this.$nextTick();

                    rvoResult = await this.syncRvo(selectedAnimals, cancelSource);
                }

                // RVO accepted the operation (or RVO sync was skipped).
                // Create the local death record.
                await this.createDeath(formData);

                // Synchronize with RVO only when no destructor UBN is supplied
                if (!this.formData.departureUbn?.trim()) {

                    this.$store.commit("setShowLoading", false);

                    const cancelSource = axios.CancelToken.source();

                    this.$store.commit("rvoSync/START_SYNC", cancelSource);

                    await this.$nextTick();

                    // RVO result:
                    //
                    // C + J
                    //     -> success
                    //
                    // C + W + N -> V + W + J
                    //     -> success + warning
                    //
                    // C + F + N
                    //     -> throws error
                    //     -> createDeath() is NOT executed
                    rvoResult = await this.syncRvo(selectedAnimals, cancelSource);
                }

                // RVO accepted the operation (or RVO sync was skipped).
                // Create the local death record.
                await this.createDeath(formData);

                // RVO accepted the request but returned a warning.
                // The warning does NOT prevent the death registration.
                // Show RVO warning only once
                const warningMessage = rvoResult?.warningMessage?.trim();
                if (warningMessage) {
                    this.$showWarning(warningMessage);
                }

                // Local death successfully created
                this.$showSuccess(this.$t("errors.Success_departure_created_successfully"));

                this.$router.push("/death");
            }
            catch (e) {
                if (!axios.isCancel(e)) {
                    const message = e.response?.data?.message || e.message || this.$t("errors.Something_went_wrong");
                    this.$showError(message);
                }
            }
            finally {

                this.$store.commit("rvoSync/STOP_SYNC");
                this.$store.commit("setShowLoading", false);
            }
        },
        async syncRvo(selectedAnimals, cancelSource) {

            let response;
            const roleName = this.$store.state.roleName;
            const isKeeper = roleName === "Keeper";
            const isAssociationAdmin = roleName === "AssociationAdmin" || roleName === "Admin";

            let keeperRVORelationNumber = '';
            if (isKeeper) {
                keeperRVORelationNumber = this.$store.state.keeperRVORelationNumber;
            }
            else if (isAssociationAdmin) {
                // Find the selected UBN
                const selectedUbn = this.formData.ubns?.find(
                    item => String(item.id) === String(this.formData.ubnId)
                );

                // Get RVO relation number from the selected UBN
                keeperRVORelationNumber = selectedUbn?.rvoRelationNumber || '';
            }

            if (selectedAnimals.length === 1) {

                const animal = selectedAnimals[0];

                const payload = {
                    rvoRelationNumber: keeperRVORelationNumber,
                    animalDeathUbn: this.formData.ubnId,
                    animalDestructorUbn: this.formData.departureUbnId,
                    animalId: animal.id,
                    animalNumber: animal.animalNumber,
                    animalLandcode: animal.countryName,
                    deathDate: this.formData.departureDate
                };

                response = await axios.post(
                    "/rvo/syncrvodeathsingle",
                    payload,
                    {
                        cancelToken: cancelSource.token
                    }
                );
            }
            else {

                const payload = {
                    rvoRelationNumber: keeperRVORelationNumber,
                    animalDeathUbn: this.formData.ubnId,
                    animalDestructorUbn: this.formData.departureUbnId,
                    deathDate: this.formData.departureDate,
                    animals: selectedAnimals.map(a => ({
                        animalNumber: a.animalNumber,
                        animalLandcode: a.countryName,
                        dierSoort: a.dierSoort ?? "3"
                    }))
                };

                response = await axios.post(
                    "/rvo/syncrvodeathmultiple",
                    payload,
                    {
                        cancelToken: cancelSource.token
                    }
                );
            }

            // RVO rejected the request.
            // Do NOT create the local death record.
            if (!response?.data?.success) {

                throw new Error(
                    response?.data?.message ||
                    this.$t("errors.RVO_sync_failed")
                );
            }

            // RVO accepted the request.
            //
            // This includes:
            // C + J
            // C + W + N -> V + W + J
            //
            // warningMessage does NOT prevent createDeath().
            return response.data;
        },
        async createDeath(formData) {

            const response = await axios.post(
                "/death/create",
                formData,
                {
                    headers: {
                        "Content-Type": "multipart/form-data"
                    }
                });

            if (!response?.data?.success) {
                throw new Error(
                    response?.data?.message ||
                    this.$t("errors.Something_went_wrong")
                );
            }

            return response.data;
        }
    }
}
</script>
<style>

.choices[data-type*=select-one]::after {
  display: none !important;
}

.choices__inner {
  border: none !important;
  background-color: transparent !important;
  box-shadow: none !important;
  position: relative;
}

.choices[data-type*=select-one] .choices__inner::before {
  content: "";
  position: absolute;
  right: 12px;
  top: 50%;
  width: 0;
  height: 0;
  pointer-events: none;
  border-left: 6px solid transparent;
  border-right: 6px solid transparent;
  border-top: 6px solid #666;
  transform: translateY(-50%);
}

/* Hide weird characters or fallback icons */
.choices__inner > *:not(.choices__item) {
  font-family: inherit !important;
  content: none !important;
}


.choices__placeholder {
  color: #999;
  font-style: italic;
}

.choices__list--single {
  padding: 0px !important;
}

</style>